import { render } from "./GroupAddOrRemove.vue?vue&type=template&id=4c37775c&scoped=true"
import script from "./GroupAddOrRemove.vue?vue&type=script&lang=js"
export * from "./GroupAddOrRemove.vue?vue&type=script&lang=js"

import "./GroupAddOrRemove.vue?vue&type=style&index=0&id=4c37775c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c37775c"]])

export default __exports__